// Whole Component Tejashwini - FIXED FLICKERING ISSUE
import  { useState, useEffect, useRef, useMemo } from "react";
import { useOtpSettings } from "./OtpContext";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import TextField from "@mui/material/TextField";
import Layout from "./layout";
import axios from "axios";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import TableSortLabel from "@mui/material/TableSortLabel";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import Stack from "@mui/material/Stack";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import TableFooter from "@mui/material/TableFooter";
import Divider from "@mui/material/Divider";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import InfoIcon from "@mui/icons-material/Info";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from 'react-router-dom';
import jsPDF from "jspdf";
import Modal from '@mui/material/Modal';
import StockIcon from "../images/quantity-01.png";
import { Typography } from "@mui/material";
import { getInstituteConfig } from "../utility/instituteConfig";



export default function Stock() {
  const [openForm, setOpenForm] = useState(false);
  const [stockLog, setStockLog] = useState({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchQuery, setSearchQuery] = useState("");
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("product_id");
  const [isAddCategoryModal, setIsAddCategoryModal] = useState(false);
  const [userId, setUserId] = useState(null);
  const [products, setProducts] = useState([]);
  const [oldQuant, setoldQuant] = useState("");
  const [productName, setProductName] = useState("");
  const [snackbarMessageColor, setSnackbarMessageColor] = useState("success");
  const [showSnackbarMessage, setShowSnackbarMessage] = useState(false);
  const [categoryLabel, setCategoryLabel] = useState("Enter Quantity");
  const [categoryNameError, setCategoryNameError] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [quantity, setQuantity] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const navigate = useNavigate();
  const [stockLogs, setStockLogs] = useState([]);
  const [description, setDescription] = useState("");
  const [descriptionError, setDescriptionError] = useState(false)

  const [oldDescription, setOldDescription] = useState("");

  const [pages, setPages] = useState(0);
  const [rowsPerPages, setRowsPerPages] = useState(5);
  const [stockOrderBy, setStockOrderBy] = useState("created_timestamp");
  const [stockOrder, setStockOrder] = useState("desc");

  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  // const [email, setEmail] = useState(process.env.REACT_APP_EMAIL);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [backendOtp, setBackendOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [verifyOTPMsg, setVerifyOTPMsg] = useState("");
  const [resendTimer, setResendTimer] = useState(600);
  const [canResend, setCanResend] = useState(true);
  const [resendCount, setResendCount] = useState(1);
  const [userMail, setUserMail] = useState();

  const searchInputRef = useRef(null);


  const Container = styled("div")({
    padding: "5rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  });
    const instituteId = localStorage.getItem("instituteId");
    const instituteEmailMap = {
      "1": process.env.REACT_APP_EMAIL_JHS,
      "2": process.env.REACT_APP_EMAIL_JPS,
    };
    const [email, setEmail] = useState(instituteEmailMap[instituteId]);
  const { isOtpEnabled } = useOtpSettings();

  const handleExport = () => {
    if (sortedRows.length === 0) {
      setSnackbarMessage("No products to download!");
      setSnackbarMessageColor("error");
      setShowSnackbarMessage(true);
      return;
    }

    // More robust calculation - convert to number and handle edge cases
    const totalInStock = sortedRows.reduce((sum, product) => {
      const qty = Number(product.quantity) || 0;
      return qty > 0 ? sum + qty : sum;
    }, 0);

    // Debug: Log the calculation
    console.log("Products with stock:", sortedRows.map(p => ({
      id: p.product_id,
      name: p.product_name,
      quantity: p.quantity
    })));
    console.log("Total In Stock:", totalInStock);

    if (totalInStock === 0) {
      setSnackbarMessage("No stock available to download!");
      setSnackbarMessageColor("error");
      setShowSnackbarMessage(true);
      return;
    }

  const institute = getInstituteConfig(instituteId);

    const doc = new jsPDF();
    doc.setFillColor("#0A64A2");
    const headerHeight = 20;
    doc.rect(0, 0, doc.internal.pageSize.getWidth(), headerHeight, "F");

    if (institute.logo) {
      doc.addImage(institute.logo, "PNG", 9, 1, 28, 18);  // ✅ dynamic
    }

    const textStartY = 11;
    doc.setFontSize(14);
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.text(
      institute.name,  // ✅ dynamic
      doc.internal.pageSize.getWidth() / 2,
      textStartY,
      { align: "center" }
    );

    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "normal");
    doc.text(
      institute.address1,  // ✅ dynamic
      doc.internal.pageSize.getWidth() / 2,
      textStartY + 14,
      { align: "center" }
    );
    doc.text(
      institute.address2,  // ✅ dynamic
      doc.internal.pageSize.getWidth() / 2,
      textStartY + 18,
      { align: "center" }
    );
    if (institute.tel) {
      doc.text(
        institute.tel,  // ✅ dynamic, skipped for JPS
        doc.internal.pageSize.getWidth() / 2,
        textStartY + 22,
        { align: "center" }
      );
    }

    const currentDate = new Date().toLocaleDateString();
    doc.setFontSize(10);
    doc.text(
      `Date: ${currentDate}`,
      doc.internal.pageSize.getWidth() - 15,
      textStartY + 42,
      { align: "right" }
    );

    const receiptTextY = textStartY + 36;
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(
      "STOCK REPORT",
      doc.internal.pageSize.getWidth() / 2,
      receiptTextY,
      { align: "center" }
    );

    const tableColumn = [
      "Product ID",
      "Product Name",
      "Category",
      "Brand",
      "Attribute",
      "Attribute Value",
      "Price",
      "In Stock",
    ];

    const tableRows = sortedRows.map((product) => {
      const qty = Number(product.quantity) || 0;
      return [
        product.product_id,
        product.product_name,
        product.category_name,
        product.brand_name,
        product.attribute_name,
        product.attribute_value,
        Number(product.price).toFixed(2),
        qty > 0 ? qty.toString() : "Out of Stock",
      ];
    });

    // Add Grand Total row
    tableRows.push([
      "",
      "",
      "",
      "",
      "",
      "",
      "Grand Total:",
      totalInStock.toString()
    ]);

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: receiptTextY + 10,
      styles: {
        fontSize: 8,
        halign: "center",
        valign: "middle",
      },
      headStyles: {
        fillColor: "#0A64A2",
        textColor: [255, 255, 255],
        fontStyle: "bold",
      },
      theme: "grid",
      didParseCell: (data) => {
        // Style the last row (Grand Total row)
        if (data.row.index === tableRows.length - 1) {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [240, 240, 240]; // Light gray background

          // Make the last two cells bolder for "Grand Total:" and the value
          if (data.column.index >= 6) {
            data.cell.styles.fontSize = 9;
          }
        }
      },
    });

    doc.save(`stock_report_${new Date().toISOString().slice(0, 10)}.pdf`);
    setSnackbarMessage("Stock report downloaded successfully!");
    setSnackbarMessageColor("success");
    setShowSnackbarMessage(true);
  };


  useEffect(() => {
    const fetchUserData = async () => {
      const email = localStorage.getItem("user_email");
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/profiledata`,
          { email },
          { headers: { user_email: email } }
        );

        if (response.status === 200) {

          setUserId(response.data.user.user_id);
          setUserMail(response.data.user.email_id)

        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchUserData();
  }, []);

  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/products/getProducts",
        {
          method: "GET",
          headers: { "Content-type": "application/json" },
          credentials: 'include',
        }
      );
      if (response.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin");
        return;
      }
      const data = await response.json();
      setProducts(data);

    } catch (error) {
      console.error("Error fetching annual subscription details:", error);
    }
  };



  const editStock = async () => {
    if (quantity === "" || isNaN(quantity)) {
      setCategoryNameError(true);
      setCategoryLabel("*Stock Required");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/stock/editProduct`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({
            product_name: productName,
            product_id: selectedProduct,
            quantity: parseInt(quantity, 10),
            quantity_description: description,
            updated_timestamp: new Date().toISOString(),
            updated_by: userId,
          }),
        }
      );

      if (response.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin");
        return;
      }

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update Stock");
      }

      const data = await response.json();

      if (data.message) {
      
       
        setSnackbarMessage("Stock Updated successfully");
        setShowSnackbarMessage(true);
        setSnackbarMessageColor("success");
       
        setIsAddCategoryModal(false);
        

        setProducts((prevState) =>
          prevState.map((product) =>
            product.product_id === selectedProduct
              ? {
                ...product,
                quantity: parseInt(quantity, 10),
                quantity_description: description,
              }
              : product
          )
        );

        //  getProducts();
         
      } else {
        throw new Error("No success message received");
      }
    } catch (error) {
      setSnackbarMessage("Failed to update Stock");
      console.error("Error updating Stock:", error);
  
    }
  };




  const handleChangePages = (event, newPage) => {
    if (newPage >= 0 && newPage < Math.ceil(stockLogs.length / rowsPerPages)) {
      setPages(newPage);
    }
  };

  const handleChangeRowsPerPages = (event) => {
    setRowsPerPages(parseInt(event.target.value, 10));
    setPages(0);
  };

  const handleStockSortRequest = (columnId) => {
    setStockOrder((prevOrder) =>
      stockOrderBy === columnId && prevOrder === "asc" ? "desc" : "asc"
    );
    setStockOrderBy(columnId);
  };

  const sortedStockLogs = useMemo(() => {
    if (!stockLogs || stockLogs.length === 0) return [];

    return [...stockLogs].sort((a, b) => {
      const aValue = a[stockOrderBy];
      const bValue = b[stockOrderBy];

      // Handle null values
      if (aValue === null && bValue === null) return 0;
      if (aValue === null) return 1;
      if (bValue === null) return -1;

      // Special handling for timestamp sorting
      if (stockOrderBy === "created_timestamp") {
        const aTime = new Date(aValue).getTime();
        const bTime = new Date(bValue).getTime();

        if (isNaN(aTime) && isNaN(bTime)) return 0;
        if (isNaN(aTime)) return 1;
        if (isNaN(bTime)) return -1;

        return stockOrder === "asc" ? aTime - bTime : bTime - aTime;
      }

      // Default comparison for other columns
      if (aValue === bValue) return 0;

      return stockOrder === "asc"
        ? aValue > bValue ? 1 : -1
        : aValue < bValue ? 1 : -1;
    });
  }, [stockLogs, stockOrderBy, stockOrder]);


  const fetchAllStockLog = async () => {
    console.log("Fetching all stock logs...");

    try {
      const response = await axios.get("/stock/getstocklogsall");

      if (response.status === 200 && Array.isArray(response.data)) {
        setStockLogs(response.data);
        setPages(0);
        setRowsPerPages(5);
      } else {
       
        setStockLogs([]);
        setPages(0);
        setRowsPerPages(5);
      }
    } catch (error) {
      console.error("Error fetching stock logs:", error);

      setStockLogs([]);
      setPages(0);
      setRowsPerPages(5);

      setStockLog({
        product_id: "N/A",
        product_name: "N/A",
        log_description: "Error fetching logs",
        created_by: "Unknown",
        datetime: "N/A",
      });
    }
  };


  const handleClose = () => {
    setIsAddCategoryModal(false);
    setQuantity('');
    setDescription('');
    setCategoryNameError(false);
    setCategoryLabel('Enter Quantity');
    setIsAddCategoryModal(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };



  const handleOpenForm = async () => {
    console.log("Open form called...");

    try {
      await fetchAllStockLog();
      console.log("Updated stock logs in handle form:", stockLog);

      setOpenForm(true);
    } catch (error) {
      console.error("Error fetching stock logs before opening form:", error);
    }
  };


  const handleCloseForm = () => {
    setOpenForm(false);
  };

  const handleQuantityClick = (productId, productQuantity, productName, existingDescription) => {
    setSelectedProduct(productId);
    setQuantity(productQuantity);
    setoldQuant(productQuantity);
    setDescription(existingDescription);
    setOldDescription(existingDescription);
    setIsAddCategoryModal(true);
    setProductName(productName);
  };
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(0);
  };

  useEffect(() => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [searchQuery]);

  const handleRequestSort = (property) => {
    const isAscending = orderBy === property && order === "asc";
    setOrder(isAscending ? "desc" : "asc");
    setOrderBy(property);
  };
  const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  };

  
  const getComparator = (order, orderBy) => {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  };
  const filteredRows = products.filter((row) => {
    const searchTerms = searchQuery.toLowerCase().split(" ").filter(Boolean);

    return searchTerms.every((term) =>
      (row.product_id && row.product_id.toString().toLowerCase().includes(term)) ||
      (row.product_name && row.product_name.toLowerCase().includes(term)) ||
      (row.category_name && row.category_name.toLowerCase().includes(term)) ||
      (row.brand_name && row.brand_name.toLowerCase().includes(term)) ||
      (row.attribute_name && row.attribute_name.toLowerCase().includes(term)) ||
      (row.attribute_value && row.attribute_value.toLowerCase().includes(term)) ||
      (row.price && row.price.toString().toLowerCase().includes(term)) ||
      (row.measurement_unit && row.measurement_unit.toString().toLowerCase().includes(term)) ||
      (row.quantity && row.quantity.toString().toLowerCase().includes(term)) ||
      (row.instock && row.instock.toString().toLowerCase().includes(term)) ||
      (row.description && String(row.description).toLowerCase().includes(term)) ||
      (row.created_timestamp && new Date(row.created_timestamp).toLocaleString().toLowerCase().includes(term))
    );

  });


// ✅ REPLACE your sortedRows with this memoized version
const sortedRows = useMemo(() => {
  return filteredRows
    .map((row, index) => ({ ...row, index: index + 1 }))
    .sort(getComparator(order, orderBy));
}, [filteredRows, order, orderBy]);


  

  const handleGetOtp = async () => {
    const otpRequiredForStock = isOtpEnabled('Stock');
    if (!otpRequiredForStock) {
          // ✅ Check for changes before saving
    if (quantity === oldQuant && description === oldDescription) {
      setSnackbarMessage("No changes detected.");
      setSnackbarMessageColor("error");
      setShowSnackbarMessage(true);
      return;
    }
      editStock();
      return;
    }
    // ✅ Check if no changes were made
    if (quantity === oldQuant && description === oldDescription) {
      setSnackbarMessage("No changes detected");
      setSnackbarMessageColor("error"); // 🔴 red color for error-type message
      setShowSnackbarMessage(true);
      return;
    }

    try {
      const response = await axios.post(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/stock/getOtpForDownloadReport",
        {
          email,
          userMail,
          quantity: Number(quantity),
          oldQuantity: Number(oldQuant),
          description: description,
          oldDescription: oldDescription,
          userId: userId,
          created_by: userId,
          productName: productName,
          productId: selectedProduct
        },
        { withCredentials: 'true' }
      );

      if (response.data.otp) {
        setBackendOtp(response.data.otp);
        setOtpSent(true);
        setResendTimer(600);
        setCanResend(false);
        setOtp(["", "", "", "", "", ""]);
        setIsOtpModalOpen(true);
      }
    } catch (error) {
      if (error.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin");
        return;
      }
      
    }
  };

  const handleVerifyOtp = (event) => {
    event.preventDefault();
    const enteredOtp = otp.join("");

    if (!enteredOtp) {
      setVerifyOTPMsg("Please enter the OTP");
      return;
    }

    if (enteredOtp === backendOtp) {
      setVerifyOTPMsg("OTP Verified Successfully");
      setIsOtpModalOpen(false);
      setOtp(["", "", "", "", "", ""]);
      setIsAddCategoryModal(false);
      setVerifyOTPMsg("");
      setResendCount(0);
      setResendTimer(600);
      setCanResend(true);
      editStock();
    } else {
      setVerifyOTPMsg("Invalid OTP");
    }
  };

  const handleOtpChange = (e, index) => {
    const value = e.target.value;

    if (/^[0-9]$/.test(value) || value === "") {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value !== "" && index < otp.length - 1) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }

      if (value === "" && index > 0) {
        const prevInput = document.getElementById(`otp-input-${index - 1}`);
        if (prevInput) {
          prevInput.focus();
        }
      }
    }
  };

  // Add this useEffect to handle the countdown timer
useEffect(() => {
  let intervalId;
  
  if (isOtpModalOpen && resendTimer > 0 && !canResend) {
    intervalId = setInterval(() => {
      setResendTimer((prevTimer) => {
        if (prevTimer <= 1) {
          setCanResend(true);
          clearInterval(intervalId);
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);
  }

  return () => {
    if (intervalId) {
      clearInterval(intervalId);
    }
  };
}, [isOtpModalOpen, canResend, resendTimer]);
 

    const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds
    ).padStart(2, "0")}`;
  };


  const handleResendOtp = () => {
    if (canResend && resendCount < 3) {
      setResendCount(prev => prev + 1);
      handleGetOtp();
      setCanResend(false);
      setResendTimer(600);
    } else {
      setVerifyOTPMsg("You have reached the maximum number of resend attempts.");
    }
  };

  const handleCloseModal = () => {
    setIsOtpModalOpen(false);
    setIsAddCategoryModal(false);

    setOtp(["", "", "", "", "", ""]);
    setVerifyOTPMsg("");
    setResendCount(0);
    setResendTimer(600);
    setCanResend(true);


  };

  return (
    <>
      <Layout />
      <h1 className="title">Stock</h1>

      <Dialog
        onClose={handleClose}
        open={isAddCategoryModal}
        sx={{
          "& .MuiDialog-paper": {
            width: "350px",
            maxWidth: "100%",
            boxShadow: "none",
            transition: "none !important",
          },
        }}
      >
        <DialogTitle
          alignSelf={"left"}
          sx={{
            "& .MuiDialog-paper": {
              width: "350px",
              maxWidth: "100%",
              boxShadow: "none",
              transition: "none !important",
            },
          }}
          BackdropProps={{
            style: {
              backgroundColor: "rgba(0,0,0,0.3)",
              transition: "none",
            },
          }}
          transitionDuration={0}
        >


          <img src={StockIcon} alt="category Image"
            style={{
              marginRight: '0.2px',
              height: '30px',
              width: '14%',
              color: '#0A64A2',
              left: '3px',
              position: 'relative',
              top: '0.1em',
            }} />


          <span style={{
            color: '#0A64A2',
            fontSize: '1em',
            position: 'relative',
            left: '3px',
            bottom: '0.2em'
          }}>
            <span> Quantity</span>
          </span>
          <Divider sx={{ background: "#0A64A2", width: "81%", height: '1.2px', left: '1.6em', position: 'absolute', bottom: '80%', }} />
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          size="small"
          sx={{
            position: "absolute",
            right: 8,
            top: 2,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent style={{ paddingTop: "4px", paddingBottom: "4px" }}>
          <Stack spacing={2} padding={1}>
            <TextField
              error={categoryNameError}
              id="quantity-field"
              label={categoryLabel}
              value={quantity}
              placeholder={selectedProduct ? ` ${quantity}` : "Enter Quantity"}
              onChange={(event) => {
                const value = event.target.value.replace(/\D/g, "").slice(0, 9);
                setQuantity(value);
              }}
              size="small"
              variant="outlined"
              sx={{ marginBottom: '8px', width: '100%', top: '1px' }}
              inputProps={{ maxLength: 9 }}
            />
            <TextField
              error={descriptionError}
              id="description-field"
              label="Description"
              value={description}
              placeholder="Enter Description"
              onChange={(event) => {
                const value = event.target.value.slice(0, 250);
                setDescription(value);
                setDescriptionError(false);
              }}
              size="small"
              variant="outlined"
              sx={{ marginBottom: '8px', width: '100%', top: '1px' }}
              inputProps={{ maxLength: 250 }}
              multiline
              rows={3}

            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "2px",
              }}
            >
              <Button
                className="save_update_btn"
                variant="contained"
                onClick={handleGetOtp}
                sx={{ mt: 2 }}
              >
                Update
              </Button>
            </div>
          </Stack>
          <Modal open={isOtpModalOpen} onClose={handleCloseModal}>
            <Box className="modalStyle">
              <IconButton
                aria-label="close"
                onClick={handleCloseModal}
                style={{ position: "absolute", top: 7, right: 10 }}
              >
                <CloseIcon />
              </IconButton>

              <h3 className="enter-otp">Enter OTP</h3>
              <Divider className="divider" />
              {verifyOTPMsg && <p className="invalid-otp">{verifyOTPMsg}</p>}

              <div className="otp-container">
                {otp.map((data, index) => (
                  <TextField
                    autoFocus={index === 0}
                    key={index}
                    value={data}
                    onChange={(e) => handleOtpChange(e, index)}
                    inputProps={{
                      maxLength: 1,
                      id: `otp-input-${index}`,
                      style: {
                        textAlign: "center",
                        fontSize: "17px",
                        width: "40px",
                        height: "40px",
                        padding: 0,
                        boxSizing: "border-box",
                      },
                    }}
                    InputProps={{
                      style: {
                        textAlign: "center",
                      },
                    }}
                    sx={{
                      "& .MuiInputBase-input": {
                        padding: 0,
                      },
                    }}
                  />
                ))}
              </div>

              <div className="otp-btn-container">
                {canResend ? (
                  <p
                    className="resend-otp"
                    style={{ color: "red", cursor: "pointer" }}
                    onClick={handleResendOtp}
                  >
                    Resend OTP {resendCount}/3
                  </p>
                ) : (
                  <p style={{ color: "red" }}>
                    Resend OTP in {formatTime(resendTimer)}
                  </p>
                )}


                <Button
                  variant="contained"
                  onClick={handleVerifyOtp}
                  className="verify-btn"
                >
                  Verify
                </Button>
              </div>
            </Box>
          </Modal>
        </DialogContent>
      </Dialog>

      <Container>
        <div className="product_container">
          <div style={{ display: "flex" }}>
            <TextField
              sx={{ minWidth: 300, mt: 0, mb: 0, pt: 0, pb: 0 }}
              label="Search..."
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={handleSearchChange}
              size="small"
              style={{ bottom: '-0.5em', border: 'none', left: '0.1em' }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton type="button" aria-label="search">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              inputRef={searchInputRef}
            />

          </div>


          <Modal
            open={openForm}
            onClose={handleCloseForm}
            BackdropProps={{
              style: {
                backgroundColor: "rgba(0,0,0,0.5)",
                transition: "none",
              },
            }}
            disableAutoFocus
            disableEnforceFocus
            disableRestoreFocus
            sx={{
              "& .MuiModal-backdrop": {
                transition: "none !important",
              },
            }}
          >
            <Box
              sx={{
                position: "absolute",
                width: "92%",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "white",
                padding: "20px",
                borderRadius: "8px",
                height: "auto",
                maxHeight: "80vh",
                display: "flex",
                flexDirection: "column",
                transition: "none !important",
              }}
            >
              <IconButton
                onClick={handleCloseForm}
                sx={{
                  position: "absolute",
                  top: "10px",
                  right: "16px",
                  color: "#A9A9A9",
                }}
              >
                <CloseIcon />
              </IconButton>
              <Typography
                variant="h6"
                sx={{
                  fontSize: "1.6em",
                  textAlign: "center",
                  fontWeight: "600",
                  color: "#2E82BD",
                  marginBottom: "0.6em",
                }}
              >
                Stock Log
              </Typography>

              <TableContainer
                component={Paper}
                sx={{
                  backgroundColor: "white",
                  maxHeight: "60vh",
                  overflowY: "auto",
                  transition: "none !important",
                  "& *": {
                    transition: "none !important",
                  },
                }}
              >
                <Table
                  stickyHeader
                  sx={{
                    tableLayout: "fixed",
                    transition: "none !important",
                    width: "100%",
                    "& *": {
                      transition: "none !important",
                    },
                  }}
                >
                  <TableHead>
                    <TableRow
                      sx={{
                        backgroundColor: "#0A64A2",
                        transition: "none !important",
                        "& > th": {
                          backgroundColor: "#0A64A2",
                          color: "white",
                          borderBottom: "none",
                          textAlign: "center",
                          borderRight: "1px solid #0A64A2",
                          transition: "none !important",
                        },
                        "& > th:last-child": { borderRight: "none" },
                      }}
                    >
                      <TableCell
                        align="center"
                        sx={{
                          color: "white",
                          borderBottom: "none",
                          backgroundColor: "#FFD700",
                          padding: "13px",
                          width: "12%",
                        }}
                      >
                        <TableSortLabel
                          active={stockOrderBy === "product_id"}
                          direction={stockOrderBy === "product_id" ? stockOrder : "asc"}
                          onClick={() => handleStockSortRequest("product_id")}
                          sx={{
                            color: "white",
                            transition: "none !important",
                            "& .MuiTableSortLabel-icon": {
                              transition: "none !important"
                            }
                          }}
                        >
                          Product ID
                        </TableSortLabel>
                      </TableCell>

                      <TableCell
                        align="center"
                        sx={{
                          color: "white",
                          borderBottom: "none",
                          backgroundColor: "#A9A9A9",
                          padding: "13px",
                          width: "18%",
                        }}
                      >
                        <TableSortLabel
                          active={stockOrderBy === "product_name"}
                          direction={stockOrderBy === "product_name" ? stockOrder : "asc"}
                          onClick={() => handleStockSortRequest("product_name")}
                          sx={{
                            color: "white",
                            transition: "none !important",
                            "& .MuiTableSortLabel-icon": {
                              transition: "none !important"
                            }
                          }}
                        >
                          Product Name
                        </TableSortLabel>
                      </TableCell>

                      <TableCell
                        align="center"
                        sx={{
                          color: "white",
                          borderBottom: "none",
                          backgroundColor: "#B0C4DE",
                          padding: "13px",
                          width: "25%",
                        }}
                      >
                        <TableSortLabel
                          active={stockOrderBy === "log_description"}
                          direction={stockOrderBy === "log_description" ? stockOrder : "asc"}
                          onClick={() => handleStockSortRequest("log_description")}
                          sx={{
                            color: "white",
                            transition: "none !important",
                            "& .MuiTableSortLabel-icon": {
                              transition: "none !important"
                            }
                          }}
                        >
                          Description
                        </TableSortLabel>
                      </TableCell>

                      <TableCell
                        align="center"
                        sx={{
                          color: "white",
                          borderBottom: "none",
                          backgroundColor: "#D3D3D3",
                          padding: "13px",
                          width: "18%",
                        }}
                      >
                        <TableSortLabel
                          active={stockOrderBy === "created_by_name"}
                          direction={stockOrderBy === "created_by_name" ? stockOrder : "asc"}
                          onClick={() => handleStockSortRequest("created_by_name")}
                          sx={{
                            color: "white",
                            transition: "none !important",
                            "& .MuiTableSortLabel-icon": {
                              transition: "none !important"
                            }
                          }}
                        >
                          Updated By
                        </TableSortLabel>
                      </TableCell>

                      <TableCell
                        align="center"
                        sx={{
                          color: "white",
                          borderBottom: "none",
                          backgroundColor: "#C0C0C0",
                          padding: "13px",
                          width: "22%",
                          pl: 2,
                        }}
                      >
                        <TableSortLabel
                          active={stockOrderBy === "created_timestamp"}
                          direction={stockOrderBy === "created_timestamp" ? stockOrder : "asc"}
                          onClick={() => handleStockSortRequest("created_timestamp")}
                          sx={{
                            color: "white",
                            transition: "none !important",
                            "& .MuiTableSortLabel-icon": {
                              transition: "none !important"
                            }
                          }}
                        >
                          Updated Date/Time
                        </TableSortLabel>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {sortedStockLogs.length > 0 ? (
                      sortedStockLogs
                        .slice(pages * rowsPerPages, pages * rowsPerPages + rowsPerPages)
                        .map((log, index) => (
                          <TableRow
                            key={`${log.product_id}-${index}`}
                            sx={{
                              height: "50px",
                              transition: "none !important",
                              "&:hover": {
                                backgroundColor: "inherit !important",
                                transition: "none !important",
                              },
                            }}
                          >
                            <TableCell align="center" sx={{ width: "12%" }}>{log.product_id || "N/A"}</TableCell>
                            <TableCell align="center" sx={{ width: "18%" }}>{log.product_name || "N/A"}</TableCell>
                            <TableCell align="center" sx={{ width: "25%" }}>{log.log_description || "N/A"}</TableCell>
                            <TableCell align="center" sx={{ width: "18%" }}>{log.created_by_name || "Unknown"}</TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                width: "22%",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {log.created_timestamp
                                ? new Date(log.created_timestamp).toLocaleString()
                                : "N/A"}
                            </TableCell>
                          </TableRow>
                        ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={6} align="center">
                          No stock logs available
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                sx={{
                  backgroundColor: "#0A64A2",
                  color: "white",
                  width: "100%",
                }}
                rowsPerPageOptions={[5, 10, 25]}
                count={stockLogs.length}
                rowsPerPage={rowsPerPages}
                page={pages}
                onPageChange={handleChangePages}
                onRowsPerPageChange={handleChangeRowsPerPages}
              />
            </Box>
          </Modal>

        </div>
        <div
          className="user_mngmt_add_delete_container"
          style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
        >

          <div className="user_mngmt_add_delete_container" style={{ display: "flex", gap: "8px" }}>
            <Button
              className="generate_barcode_btn"
              variant="contained"
              onClick={handleOpenForm}
              sx={{ background: "#0A64A2", color: "#fff", width: '9em', bottom: '2.6em', left: "12px" }}
            >Stock Log</Button>

            <Button
              className="generate_barcode_btn"
              variant="contained"
              onClick={handleExport}
              sx={{ background: "#0A64A2", color: "#fff", left: "4px", bottom: '2.6em' }}
            > Download Report</Button>
          </div>
        </div>

        <Box className="table-container" sx={{ marginTop: "-2rem" }}>
          <Paper className="table-paper" sx={{ overflow: "hidden" }}>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 1000 }}>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#0A64A2" }}>
                    <TableCell
                      align="center"
                      sx={{
                        color: "white",
                        fontWeight: 400,
                        padding: "12px 16px",
                        borderRight: "1px solid #0A64A2",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      <TableSortLabel
                        active={orderBy === "product_id"}
                        direction={orderBy === "product_id" ? order : "asc"}
                        onClick={() => handleRequestSort("product_id")}
                        sx={{
                          color: "white !important",
                          "& .MuiTableSortLabel-icon": {
                            color: "white !important",
                          },
                        }}
                      >
                        Product Id
                      </TableSortLabel>
                    </TableCell>

                    <TableCell
                      align="center"
                      sx={{
                        color: "white",
                        fontWeight: 400,
                        padding: "12px 16px",
                        borderRight: "1px solid #0A64A2",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      <TableSortLabel
                        active={orderBy === "product_name"}
                        direction={orderBy === "product_name" ? order : "asc"}
                        onClick={() => handleRequestSort("product_name")}
                        sx={{
                          color: "white !important",
                          "& .MuiTableSortLabel-icon": {
                            color: "white !important",
                          },
                        }}
                      >
                        Product Name
                      </TableSortLabel>
                    </TableCell>

                    <TableCell
                      align="center"
                      sx={{
                        color: "white",
                        fontWeight: 400,
                        padding: "12px 16px",
                        borderRight: "1px solid #0A64A2",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      <TableSortLabel
                        active={orderBy === "category_name"}
                        direction={orderBy === "category_name" ? order : "asc"}
                        onClick={() => handleRequestSort("category_name")}
                        sx={{
                          color: "white !important",
                          "& .MuiTableSortLabel-icon": {
                            color: "white !important",
                          },
                        }}
                      >
                        Category
                      </TableSortLabel>
                    </TableCell>

                    <TableCell
                      align="center"
                      sx={{
                        color: "white",
                        fontWeight: 400,
                        padding: "12px 16px",
                        borderRight: "1px solid #0A64A2",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      <TableSortLabel
                        active={orderBy === "brand_name"}
                        direction={orderBy === "brand_name" ? order : "asc"}
                        onClick={() => handleRequestSort("brand_name")}
                        sx={{
                          color: "white !important",
                          "& .MuiTableSortLabel-icon": {
                            color: "white !important",
                          },
                        }}
                      >
                        Brand
                      </TableSortLabel>
                    </TableCell>

                    <TableCell
                      align="center"
                      sx={{
                        color: "white",
                        fontWeight: 400,
                        padding: "12px 16px",
                        borderRight: "1px solid #0A64A2",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      <TableSortLabel
                        active={orderBy === "attribute_name"}
                        direction={orderBy === "attribute_name" ? order : "asc"}
                        onClick={() => handleRequestSort("attribute_name")}
                        sx={{
                          color: "white !important",
                          "& .MuiTableSortLabel-icon": {
                            color: "white !important",
                          },
                        }}
                      >
                        Attribute
                      </TableSortLabel>
                    </TableCell>

                    <TableCell
                      align="center"
                      sx={{
                        color: "white",
                        fontWeight: 400,
                        padding: "12px 16px",
                        borderRight: "1px solid #0A64A2",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      <TableSortLabel
                        active={orderBy === "attribute_value"}
                        direction={orderBy === "attribute_value" ? order : "asc"}
                        onClick={() => handleRequestSort("attribute_value")}
                        sx={{
                          color: "white !important",
                          "& .MuiTableSortLabel-icon": {
                            color: "white !important",
                          },
                        }}
                      >
                        Attribute Value
                      </TableSortLabel>
                    </TableCell>

                    <TableCell
                      align="center"
                      sx={{
                        color: "white",
                        fontWeight: 400,
                        padding: "12px 16px",
                        borderRight: "1px solid #0A64A2",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      <TableSortLabel
                        active={orderBy === "price"}
                        direction={orderBy === "price" ? order : "asc"}
                        onClick={() => handleRequestSort("price")}
                        sx={{
                          color: "white !important",
                          "& .MuiTableSortLabel-icon": {
                            color: "white !important",
                          },
                        }}
                      >
                        Price
                      </TableSortLabel>
                    </TableCell>

                    <TableCell
                      align="center"
                      sx={{
                        color: "white",
                        fontWeight: 400,
                        padding: "12px 16px",
                        borderRight: "1px solid #0A64A2",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      <TableSortLabel
                        active={orderBy === "quantity"}
                        direction={orderBy === "quantity" ? order : "asc"}
                        onClick={() => handleRequestSort("quantity")}
                        sx={{
                          color: "white !important",
                          "& .MuiTableSortLabel-icon": {
                            color: "white !important",
                          },
                        }}
                      >
                        In Stock
                      </TableSortLabel>
                    </TableCell>

                    <TableCell
                      align="center"
                      sx={{
                        color: "white",
                        fontWeight: 400,
                        padding: "12px 16px",
                        borderRight: "1px solid #0A64A2",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Description
                    </TableCell>

                    <TableCell
                      align="center"
                      sx={{
                        color: "white",
                        fontWeight: 400,
                        padding: "12px 16px",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Add Quantity
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {sortedRows
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => (
                      <TableRow
                        key={row.product_id}
                        hover
                        sx={{
                          "&:nth-of-type(odd)": { backgroundColor: "#f9f9f9" },
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell align="center">{row.product_id}</TableCell>
                        <TableCell align="center">{row.product_name}</TableCell>
                        <TableCell align="center">{row.category_name}</TableCell>
                        <TableCell align="center">{row.brand_name}</TableCell>
                        <TableCell align="center">
                          {row.attribute_name}
                        </TableCell>
                        <TableCell align="center">{row.attribute_value}</TableCell>
                        <TableCell align="center">{row.price}</TableCell>
                        <TableCell align="center">{row.quantity}</TableCell>

                        <TableCell align="center">
                          <Tooltip title={row.quantity_description || ""} placement="top">
                            <IconButton
                              size="small"
                              sx={{
                                color: "#0A64A2",
                                "&:hover": { backgroundColor: "transparent" },
                              }}
                            >
                              <InfoIcon fontSize="medium" />
                            </IconButton>
                          </Tooltip>
                          
                        </TableCell>

                        <TableCell align="center">
                          <Button
                            onClick={() =>
                              handleQuantityClick(
                                row.product_id,
                                row.quantity,
                                row.product_name,
                                row.quantity_description
                              )
                            }
                            sx={{
                              minWidth: "auto",
                              padding: 0,
                              "&:hover": { backgroundColor: "transparent" },
                            }}
                          >
                            <img
                              src={StockIcon}
                              alt="Add Quantity"
                              style={{
                                height: "26px",
                                width: "26px",
                                position: "relative",
                                top: "0.2em",
                              }}
                            />
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>

                <TableFooter>
                  <TableRow>
                    <TablePagination
                      sx={{

                        maxHeight: Math.min(sortedStockLogs.length, rowsPerPages) * 50 + 60,
                        overflowY: sortedStockLogs.length > rowsPerPages ? "auto" : "visible",
                        backgroundColor: "#0A64A2",
                        color: "white",
                        width: "100%",
                      }}
                      rowsPerPageOptions={[5, 10, 25]}
                      colSpan={10}
                      count={sortedRows.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Paper>
        </Box>

      </Container>
      <Snackbar
        open={showSnackbarMessage}
        autoHideDuration={2000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={() => setShowSnackbarMessage(false)}
      >
        <Alert severity={snackbarMessageColor} variant="filled">
          {snackbarMessage}
        </Alert>
      </Snackbar>




    </>
  );
}
